import React, {useEffect} from 'react';
import {Link, useLocation} from 'react-router-dom';

import './payment.css';
import clsx from 'clsx';
import {Alert, AlertTitle} from '@mui/material';

interface IPaymentPage {
    setCurrentPageClass: React.Dispatch<React.SetStateAction<string>>;
    children: React.ReactNode;
}

export default function PaymentTemplate({children, setCurrentPageClass}: IPaymentPage) {
    useEffect(() => {
        setCurrentPageClass('bg payment');
    });

    const links = [
        {label: 'Оплата услуг', path: '/payment'},
        // {label: 'Пополнение баланса', path: '/payment/paymenttowallet'},
        {label: 'История заказов', path: '/payment/history'},
    ];

    const location = useLocation();

    const routeMap: Record<string, any> = {
        '/payment': {title: 'Оплата услуг', baseRoute: '/payment'},
        '/payment/custompayment': {title: 'Оплата услуг', baseRoute: '/payment'},
        '/payment/confirmpayment': {title: 'Оплата услуг', baseRoute: '/payment'},
        // '/payment/paymenttowallet': {title: 'Пополнение баланса', baseRoute: '/payment/paymenttowallet'},
        '/payment/history': {title: 'История заказов', baseRoute: '/payment/history'},
    };

    return (
        <section className={'content'}>
            <div className={'header'}>
                <h1 className={'title'}>
                    <span>Оплата</span>
                </h1>
            </div>
            <nav className="nav-tabs">
                {links.map(link => (
                    <Link
                        key={link.path}
                        to={link.path}
                        className={clsx('tab-link', {active: routeMap[location.pathname]?.baseRoute === link.path})}
                    >
                        {link.label}
                    </Link>
                ))}
            </nav>
            <div className={'workspace'}>
                <section className={'content'}>{children}</section>
            </div>
        </section>
    );
}
